export const BOT_NAMES = {
  EMMA: "Emma",
  ALLIE: "Allie",
  LITTLE_ANN: "Little Ann",
};
